@if (showMainChrome()) {
  <app-header></app-header>
}
<router-outlet></router-outlet>
<app-toaster></app-toaster>

@if (isLoggingOutAfterPasswordChange) {
  <div class="logout-overlay">
    <div class="logout-overlay__content">
      <div class="logout-overlay__spinner"></div>
      <p class="logout-overlay__message">Password changed successfully. Logging out...</p>
    </div>
  </div>
}
